var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    class: _vm.$style.labelContainer
  }, [_c('div', [_c('p', {
    staticClass: "p1",
    class: _vm.$style.label
  }, [_vm._v(_vm._s(_vm.label) + ":")])])]), _c('Multiselect', {
    staticClass: "motto-multi-select motto-multi-select-input-multiple",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "options": _vm.options,
      "taggable": true,
      "multiple": true,
      "show-labels": false
    },
    on: {
      "tag": _vm.addTag,
      "input": function input(changedValue) {
        _vm.$emit('input', changedValue);
      }
    },
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }